import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=1269e53e&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=1269e53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269e53e",
  null
  
)

export default component.exports